import { render, staticRenderFns } from "./TopBarNavigation.vue?vue&type=template&id=b2fd5068&scoped=true"
import script from "./TopBarNavigation.vue?vue&type=script&lang=js"
export * from "./TopBarNavigation.vue?vue&type=script&lang=js"
import style0 from "./TopBarNavigation.vue?vue&type=style&index=0&id=b2fd5068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fd5068",
  null
  
)

export default component.exports